import Vue from 'vue';
import dayjs from 'dayjs';

export default {
  install: () => {
    // 日期格式化
    Vue.filter('dateFilter', (val, formatString = 'YYYY-MM-DD HH:mm:ss') => {
      return dayjs(val || 0).format(formatString);
    });

    // 金额格式化
    Vue.filter('moneyFilter', val => {
      if (isNaN(val)) {
        return val;
      }
      return String(val).replace(/(?=\B(?:\d{3})+\b)(\d{3}(?:\.\d+$)?)/g, ',$1');
    });

    // 电话格式化
    Vue.filter('phoneFilter', (val, formatString = '****') => {
      if ((val || '').length !== 11) {
        return val;
      }
      return val.slice(0, 3) + formatString + val.slice(-4);
    });

    // 金额格式化
    Vue.filter('formatTotalCount', val => {
      const unit = 100000000;
      if (val < unit) {
        return val.toLocaleString();
      }
      return `${(val / unit).toFixed(3)}亿`;
    });
  }
};
